<template>
  <div class="bg-fa of" style="padding: 40px;">
    <el-alert
        title="支付成功！"
        type="success">
    </el-alert>
    <el-button type="primary" @click="goToCzPage">返回充值页面</el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: '支付成功！'
    };
  },
  methods: {
    goToCzPage() {
      this.$router.push({ path: '/czpage' });
    }
  }
};
</script>

<style scoped>
.bg-fa {
  background-color: #f9f9f9;
}

.of {
  overflow: hidden;
}

</style>